import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Award, ShieldCheck, FileCheck2, MapPin, ArrowRight, BadgeCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  {
    icon: Award,
    title: "15+ Years on the Tools",
    desc: "15+ years on the tools across Albany homes and businesses — not a fly-in contractor.",
  },
  {
    icon: MapPin,
    title: "Local to Albany",
    desc: "Based in Albany, working across the Great Southern — you deal directly with Derek, not a call centre.",
  },
  {
    icon: ShieldCheck,
    title: "Licensed & Insured",
    desc: "Fully licensed, fully insured. Every job done to standard, every time.",
  },
  {
    icon: FileCheck2,
    title: "Free Quotes, No Obligation",
    desc: "Send the details through and get a straight answer and a fair price.",
  },
  {
    icon: BadgeCheck,
    title: "ECA WA Member",
    desc: "Member of the Electrical Contractors Association of WA — held to the state's highest standards of workmanship, safety and professionalism. A name Albany can trust.",
  },
];

const cardWidth =
  "w-full sm:w-[calc(50%-0.375rem)] md:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.875rem)]";

const WhyUs = () => (
  <section id="about" className="bg-white py-16 md:py-28" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <p className="mb-3 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-petrol md:text-sm">
          <ShieldCheck className="h-3.5 w-3.5" strokeWidth={1.75} />
          03 — Why Exchange
        </p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tight text-petrol md:text-6xl">
          No shortcuts taken
        </h2>
      </Reveal>
      <div className="mt-10 flex flex-wrap justify-center gap-3 md:mt-16 md:gap-5">
        {POINTS.map((p, i) => (
          <motion.div
            key={p.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.08 * i, ease: [0.16, 1, 0.3, 1] }}
            className={`${cardWidth} border-2 border-ink bg-white p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-copper hover:shadow-[6px_6px_0_#c8925a] md:p-5`}
            data-testid={`why-us-card-${i}`}
          >
            <p.icon className="h-7 w-7 text-petrol" strokeWidth={1.5} />
            <h3 className="mt-3 font-display text-sm font-bold uppercase tracking-tight text-ink md:mt-4 md:text-base">
              {p.title}
            </h3>
            <p className="mt-1.5 text-xs leading-relaxed text-ink/60 md:mt-2 md:text-sm">{p.desc}</p>
          </motion.div>
        ))}
      </div>
      <Reveal className="mt-12 text-center md:mt-14">
        <Link
          to="/services"
          data-testid="why-us-services-button"
          className="group inline-flex items-center gap-2 border-2 border-ink px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:border-copper hover:bg-copper"
        >
          See Services
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default WhyUs;
